import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { PlusIcon, ProjectNameIcon, StatusCheckIcon, EyeIcon, EditIcon, DetailIcon, ProjectAvatar, UserIcon } from 'assets';
import { useSelector } from 'react-redux';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import moment from 'moment';
import { InventoryProMutation, InventoryProUpdateMutation } from 'shared/services/inventory_service/InventoryService';
import { useLocation, useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import UpdateInvenotyMod from 'shared/modal/update_inventory/UpdateInvenotyMod';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { isRestrictActions } from 'shared/utils/Helper';

export default function DetailInventory({ }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [openinventory, setOpeninventory] = useState(false);
    const [dataList, setdataList] = useState();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const IdProductInven = location.state.data;
    const [actualStock, setActualStock] = useState(IdProductInven?.quantity || 0);
    const { mutate: InProMutate, data: InventoryProduct, isLoading, isSuccess: ProductIsSuccess } = InventoryProMutation();
    const { mutate: InventoryProdUpdateMutate, isSuccess: isSuccessUpdateInventory, isLoading: updateInvetoryLoading } = InventoryProUpdateMutation();
    console.log(IdProductInven.inventory_id, "IdProductInven");

    const edites = (data) => {
        setOpeninventory(true);
        setdataList(data);
    };

    useEffect(() => {
        if (isSuccessUpdateInventory) {
            getInventoryList();
            closeProductHandler();
        } else {
            getInventoryList();
        }
    }, [isSuccessUpdateInventory]);
    const getInventoryList = () => {
        if (!IdProductInven) return;
        let obj = {
            product: IdProductInven.product?._id,
            brand: IdProductInven.brand?._id,
            product_category: IdProductInven.product_category?._id,
            sub_category: IdProductInven.sub_category?._id,
            warehouse: IdProductInven.warehouse?._id,
            sku: IdProductInven.sku
        };
        InProMutate(obj);
    };
    const closeProductHandler = () => {
        setOpeninventory(false);
    };
    const updateHandler = (payload) => {
        // Calculate the difference to update our local actualStock state
        const stockDiff = (Number(payload.stockIn) || 0) - (Number(payload.stockOut) || 0);
        InventoryProdUpdateMutate(payload, {
            onSuccess: () => {
                setActualStock(prev => prev + stockDiff);
            }
        });
    };
    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Order Number
                    </div>
                ),
                accessor: 'order_number',
                Cell: ({ row }) => {
                    const itData = row.original?.it;
                    const isSummaryRow = row.original?.isTransferRow;
                    const orderNum = row.original?.po?.order_number || row.original?.order_number || row.original?.transfer_number || '-';

                    const handleNavigate = () => {
                        if (isSummaryRow) {
                            navigate(routeConstant.admin.internalTransfer.list.path);
                        } else if (itData) {
                            navigate(routeConstant.admin.internalTransfer.viewit.path, { state: { data: itData } });
                        }
                    }

                    return (
                        <div
                            onClick={handleNavigate}
                            style={{
                                cursor: (isSummaryRow || itData) ? 'pointer' : 'default',
                                color: (isSummaryRow || itData) ? '#4a86f7' : 'inherit',
                                fontWeight: (isSummaryRow || itData) ? '600' : 'normal',
                                textDecoration: (isSummaryRow || itData) ? 'underline' : 'none'
                            }}
                        >
                            {orderNum}
                        </div>
                    );
                }
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        SKU
                    </div>
                ),
                accessor: 'sku',
                Cell: ({ row }) => <div>{row.original?.sku}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <UserIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Supplier
                    </div>
                ),
                accessor: 'supplier',
                Cell: ({ row }) => <div>{row.original?.po?.supplier?.name || row.original?.supplier?.name || '-'}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Name
                    </div>
                ),
                accessor: 'name',
                Cell: ({ row }) => <div>{row.original?.product?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Category
                    </div>
                ),
                accessor: 'product_category',
                Cell: ({ row }) => <div>{row.original?.product_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Issue Date
                    </div>
                ),
                accessor: 'created_at',
                Cell: ({ row }) => (
                    <div>
                        {row?.original?.updated_at || row?.original?.created_at
                            ? moment(row?.original?.updated_at || row?.original?.created_at).format('DD, MMM YYYY')
                            : '-'}
                    </div>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        PO QTY
                    </div>
                ),
                accessor: 'POquantity',
                Cell: ({ row }) => <div>{row.original?.poQty}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        RM QTY
                    </div>
                ),
                accessor: 'Remaining',
                Cell: ({ row }) => <div>{row.original?.remaining}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        In Stock
                    </div>
                ),
                accessor: 'quantity',
                Cell: ({ row }) => <div>{row.original?.quantity}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        WarehOuse
                    </div>
                ),
                accessor: 'warehouse',
                Cell: ({ row }) => <div>{row.original?.warehouse?.code}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <EditIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Update
                    </div>
                ),
                accessor: 'view&print',
                Cell: ({ row }) => {
                    if (row.original?.isTransferRow) return null;
                    return <EditIcon onClick={() => {
                        if (isRestrictActions(screenEnum.inventory, screenActionEnum.update)) {
                            edites(row?.original)
                        }
                    }} />
                }
            }
        ],

        [theme, showModal]
    );

    const tableData = React.useMemo(() => {
        if (!InventoryProduct) return [];

        // Filter out items only when both remaining and quantity are 0
        const filteredProducts = InventoryProduct.filter(item => {
            const quantity = Number(item?.quantity) || 0;
            const remaining = Number(item?.remaining) || 0;
            return quantity > 0 || remaining > 0;
        });

        const detailedSum = filteredProducts.reduce((acc, ii) => acc + (Number(ii?.quantity) || 0), 0);
        const transferQty = actualStock - detailedSum;

        if (transferQty > 0) {
            const transferRow = {
                po: { order_number: 'Internal Transfers', supplier: { name: 'Various' } },
                sku: IdProductInven?.sku,
                product: IdProductInven?.product,
                product_category: IdProductInven?.product_category,
                warehouse: IdProductInven?.warehouse,
                quantity: transferQty,
                updated_at: IdProductInven?.updated_at,
                isTransferRow: true
            };
            return [...filteredProducts, transferRow];
        }
        return filteredProducts;
    }, [InventoryProduct, actualStock, IdProductInven]);

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div className={styles.Header}>
                    <Heading heading={'Inventory Detail'} headingStyle={styles.Heading} />
                    <div className="d-flex flex-column align-items-end">
                        <Heading
                            heading={`Actual Stock : ${actualStock}`}
                            headingStyle={classNames(styles.Heading, "mb-0")}
                        />
                    </div>
                </div>
                {tableData?.length > 0 ? (
                    <GenericTable columns={columns} data={tableData} TableWrapperStyle={classNames(styles.Table)} />
                ) : (
                    <div className={classNames("text-center p-5 mt-4 rounded-3", styles.EmptyState)} style={{ background: theme === 'dark' ? '#262c48' : '#f8f9fa', border: `1px dashed ${theme === 'dark' ? '#353f5f' : '#dee2e6'}` }}>
                        <div className="mb-3">
                            <DetailIcon size={48} style={{ opacity: 0.5, fontSize: '40px' }} />
                        </div>
                        <h5 className={classNames(theme === 'dark' ? 'text-white' : 'text-dark')}>No Records Found for this Warehouse</h5>
                        <p className={classNames(theme === 'dark' ? 'text-muted' : 'text-secondary', "mb-0")}>
                            The stock for SKU <strong>{IdProductInven?.sku}</strong> in <strong>{IdProductInven?.warehouse?.code}</strong> might have been fully transferred to another warehouse, sold, or updated.
                        </p>
                        <p className="small mt-2">Check the <strong style={{ color: '#4a86f7', cursor: 'pointer' }} onClick={() => navigate(routeConstant.admin.internalTransfer.list.path)}>Internal Transfer</strong> section for movement history.</p>
                    </div>
                )}
                <UpdateInvenotyMod show={openinventory} handleClose={closeProductHandler} data={dataList} updateHandler={updateHandler} />
            </div>
            {(isLoading && <OverlayLoading />) || (updateInvetoryLoading && <OverlayLoading />)}
        </DashboardWrapper>
    );
}
